// update state
const setUserFullData = (payload) => {
    return {
        type: "USERFULLDATA",
        payload
    }

}

export default setUserFullData;




// WEBPACK FOOTER //
// ./src/actions/setUserFullData.js